import { IAction } from './../../models/action/core.d';
import { actions } from "../constants/madlenIntegration";
import * as actionTypes from '../../models/action/madlenIntegration';
import { IMadlenActivityData, IMadlenAIContent } from "../../models/components/madlen-integrations";
import { ActivityTypeEnums } from "../../models/enums/ActivityType";
import { IPagedQuery } from "../../models/components/paginate";


export function GetActivityListMadlen(
    CourseId: string,
    ClassId: string | null,
    TermWeekId: string | null,
    weekZero?: boolean | undefined,
    IsWeekly?: boolean | null,
    Take?: number,
    Skip?: number,
    OrderBy?: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set'): actionTypes.IGetMadlenActivityData {
    return {
        CourseId,
        ClassId,
        TermWeekId,
        weekZero,
        IsWeekly,
        Take,
        Skip,
        OrderBy,
        spinnerId,
        spinnerType,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_GET_LIST
    };
}

export function SetActivityListMadlen(results: Array<IMadlenActivityData>): actionTypes.ISetMadlenActivityData {
    return {
        results,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_SET_LIST
    };
}

export function CreateSendContentJob(courseId: string, callback?: (value: boolean) => void): actionTypes.ICreateSendContentJob {
    return {
        courseId,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_CREATE_SEND_CONTENT_JOB,
        callback
    };
}

export function MadlenSendContentAI(
    CourseId: string,
    ClassId: string,
    DisAllowedIds: Array<string> | string,
    isAll: boolean,
    ActivitiesWithType: Array<{ activityId: string; activityType: ActivityTypeEnums | null }>,
    AISendedId: string,
    JobId: string,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void): actionTypes.IMadlenAISended {
    return {
        CourseId,
        ClassId,
        DisAllowedIds,
        isAll,
        ActivitiesWithType,
        AISendedId,
        JobId,
        type: actions.MADLEN_SEND_CONTENT,
        timestamp: Date.now(),
        spinnerId,
        spinnerType,
        callback
    };
}


export function GetAIContents(
    CourseId: string,
    Status?: number,
    Take?: number,
    Page?: number,
    OrderByAsc?: boolean | null,
    Query?: string | null,
    spinnerId?: string,
    spinnerType?: 'get' | 'set',
    callback?: (value: any) => void): actionTypes.IGetContents {
    return {
        CourseId,
        Status,
        Take,
        Page,
        OrderByAsc,
        Query,
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_GET_CONTENTS
    };
}


export function SetContentListMadlen(results: Array<IMadlenAIContent>, filters: IPagedQuery, status: number): actionTypes.ISetPendingAndSentData {
    return {
        results,
        filters,
        status,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_SET_CONTENTS
    };
}

export function GetMadlenUrl(spinnerId?: string, spinnerType?: 'get' | 'set', callback?: (value: any) => void): IAction {
    return {
        spinnerId,
        spinnerType,
        callback,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_GET_MADLEN_URL
    };
}

export function SetMadlenUrl( resultUrl: string): actionTypes.ISetMadlenUrl {
    return {
        resultUrl,
        timestamp: Date.now(),
        type: actions.MADLEN_INTEGRATION_SET_MADLEN_URL
    };
}

